import { useDataSubmit, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'task',
  })
  let setLoading = useDataChange({
    viewPath: props.viewPath,
    context: 'loading',
  })

  return async function onClick() {
    setLoading(true)
    try {
      await submit({ type: 'generate_letter' })
    } finally {
      setLoading(false)
    }
  }
}
